
 //namespace MyModule {
export abstract  class  BaseModel {
    CompanyId:number;
     IUser:string;
    Response:Response;
    EmpCode:number;
    //  constructor(CompanyId:number,IUser:string,Response:Response ) {
    //       this.CompanyId=CompanyId;
    //       this.IUser=IUser;
    //       this.Response=Response;
    //  }
}

//}